const PUBLIC_API_KEY = 'publicApiKey'
const CHECKOUT_RETURN_URL = 'checkoutReturnUrl'

export const setPublicApiKeyInLS = (publicApiKey: string): void => {
  localStorage.setItem(PUBLIC_API_KEY, publicApiKey)
}

export const getPublicApiKeyInLS = () => { 
  return localStorage.getItem(PUBLIC_API_KEY)
}

export const setCheckoutReturnUrlInLS = (checkoutReturnUrl?: string): void => {  
  if (checkoutReturnUrl) {
    localStorage.setItem(CHECKOUT_RETURN_URL, checkoutReturnUrl)
  } else {
    localStorage.removeItem(CHECKOUT_RETURN_URL)
  }
}

export const getCheckoutReturnUrlInLS = () => {  
  return localStorage.getItem(CHECKOUT_RETURN_URL)
}
